import {Directive, ViewContainerRef} from '@angular/core';

@Directive({
  selector: '[sptLoadComponent]'
})
export class LoadComponentDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
